import { BorderType, PaddingType, AlignType } from 'common/types/styleTypes'
import {
  WebsiteButtonAndFormFieldTypes,
  WebsiteSettingsTypographyTypeEnum,
} from 'src/shared/types/website-settings-types'
import { useCalculateFontFamily } from '../use-calculate-typography/use-calculate-font-family'
import { useCalculateFontSize } from '../use-calculate-typography/use-calculate-font-size'
import { useCalculateLineHeight } from '../use-calculate-typography/use-calculate-line-height'
import { useCalculateTextAlign } from '../use-calculate-typography/use-calculate-text-align'
import { useCalculateLetterSpacing } from '../use-calculate-typography/use-calculate-letter-spacing'
import { useCalculateBorder } from '../use-calculate-border'
import { useCalculatePadding } from '../use-calculate-padding'
import { useCalculateFontStyle } from '../use-calculate-typography/use-calculate-font-style'
import { useCalculateFontWeight } from '../use-calculate-typography/use-calculate-font-weight'

export const useCalculateButtonStyles = ({
  border,
  mobileBorder,
  padding,
  mobilePadding,
  fontFamily,
  mobileFontFamily,
  fontSize,
  mobileFontSize,
  lineHeight,
  mobileLineHeight,
  textAlign,
  mobileTextAlign,
  letterSpacing,
  mobileLetterSpacing,
  fontStyle,
  mobileFontStyle,
  fontWeight,
  mobileFontWeight,
  buttonType = WebsiteSettingsTypographyTypeEnum.PrimaryButton,
}: {
  border?: Partial<BorderType>
  mobileBorder?: Partial<BorderType>
  padding?: Partial<PaddingType>
  mobilePadding?: Partial<PaddingType>
  buttonType?: WebsiteButtonAndFormFieldTypes
  fontSize?: number
  mobileFontSize?: number
  lineHeight?: number
  mobileLineHeight?: number
  textAlign?: AlignType
  mobileTextAlign?: AlignType
  letterSpacing?: number
  mobileLetterSpacing?: number
  fontFamily?: string
  mobileFontFamily?: string
  fontStyle?: string
  mobileFontStyle?: string
  fontWeight?: string
  mobileFontWeight?: string
}) => {
  const returnUseCalculatePadding = useCalculatePadding({
    padding,
    mobilePadding,
    type: buttonType,
  })

  const returnUseCalculateBorder = useCalculateBorder({
    border,
    mobileBorder,
    type: buttonType,
  })
  const returnUseCalculateFontFamily = useCalculateFontFamily({
    fontFamily,
    mobileFontFamily,
    typographyType: buttonType,
  })

  const returnUseCalculateFontStyle = useCalculateFontStyle({
    fontStyle,
    mobileFontStyle,
  })

  const returnUseCalculateFontWeight = useCalculateFontWeight({
    fontWeight,
    mobileFontWeight,
  })

  const returnUseCalculateFontSize = useCalculateFontSize({
    fontSize,
    mobileFontSize,
    typographyType: buttonType,
  })

  const returnUseCalculateLineHeight = useCalculateLineHeight({
    fontSize,
    mobileFontSize,
    lineHeight,
    mobileLineHeight,
    typographyType: buttonType,
  })

  const returnUseCalculateTextAlign = useCalculateTextAlign({
    textAlign,
    mobileTextAlign,
    typographyType: buttonType,
  })

  const returnUseCalculateLetterSpacing = useCalculateLetterSpacing({
    letterSpacing,
    mobileLetterSpacing,
    typographyType: buttonType,
  })

  return {
    ...returnUseCalculatePadding,
    ...returnUseCalculateBorder,
    ...returnUseCalculateFontSize,
    calculatedFontSize: {
      mobile: returnUseCalculateFontSize.calculatedFontSize.mobile as number,
      desktop: returnUseCalculateFontSize.calculatedFontSize.desktop as number,
    },
    ...returnUseCalculateLineHeight,
    ...returnUseCalculateTextAlign,
    ...returnUseCalculateLetterSpacing,
    ...returnUseCalculateFontFamily,
    ...returnUseCalculateFontWeight,
    ...returnUseCalculateFontStyle,
  }
}
